howspace.commentsTrait.attachmentHandlers = (() => {
    'use strict';

    real.onTierReady(real.TIER_2, () => {
        real.events.on('uploadedfile:stored', notification => {
            if (notification?.object?.uploadedfile?.upload_process_metadata?.token) {
                const token = notification.object.uploadedfile.upload_process_metadata.token;
                // This is used for processing the uploaded file in the widget.
                if ($('.widget[data-attachment-upload-token="' + token + '"]').length > 0) {
                    const widget = $('.widget[data-attachment-upload-token="' + token + '"]');
                    const opener = widget.data('opener');
                    getUploadedFileAndPreview(widget, opener, notification.object.uploadedfile);
                }
                // This is used for processing the rotated file in the widget.
                if ($('.widget[data-attachment-rotating-token="' + token + '"]').length > 0) {
                    const widget = $('.widget[data-attachment-rotating-token="' + token + '"]');
                    handleRotateCompleted(widget, notification.object.uploadedfile);
                }
            }
        });
    });

    const getParent = opener => {
        const comment = $(opener).closest('.comment-input');
        const reply = $(opener).closest('.reply-input');
        let parent;

        if (reply.length > 0) {
            parent = reply;
        } else if (comment.length > 0) {
            parent = comment;
        }

        return parent;
    }

    const getUploadedFileAndPreview = (widget, opener, file) => {
        const parentContainer = getParent(opener);
        if (!parentContainer) {
            return;
        }
        const recordingContainer = parentContainer.find('.recording');
        const progressBar = parentContainer.find('.howspace-progress');

        // If the recording container is visible, hide it and show the attachment.
        if (recordingContainer.length > 0 && recordingContainer.is(':visible')) {
            howspace.animate(recordingContainer, 'slideUp', 350, () => {
                recordingContainer.removeAttr('style').addClass('d-none');
                addAttachment(widget, parentContainer, file);
                parentContainer.find('.send-action-btn').prop('disabled', false).focus();
            });
        } else {
            howspace.components.progress.update(progressBar, 100, () => {
                setTimeout(() => {
                    progressBar.addClass('d-none');
                    howspace.components.progress.reset(progressBar);
                    addAttachment(widget, parentContainer, file);
                    parentContainer.find('.send-action-btn').prop('disabled', false).focus();
                }, 500);
            });
        }
    };

    const handleRotateCompleted = (widget, uploadedFile) => {
        const token = uploadedFile.upload_process_metadata.token;
        const attachment = widget.find('.attachment.rotating[data-attachment-rotating-token="' + token + '"]');
        if (attachment.length === 0) {
            return;
        }

        howspace.components.destroy(attachment);
        const fileId = uploadedFile.id;
        if (attachment.find('.howspace-picture').length > 0) {
            const picture = attachment.find('.howspace-picture');
            howspace.components.picture.replacePicture(
                picture[0],
                fileId,
                real.baseUri + '/uploadedfile/' + fileId + '/view',
                uploadedFile.metadata
            );
        }

        if (attachment.find('.howspace-video-player').length > 0) {
            const videoPlayer = attachment.find('.howspace-video-player');
            videoPlayer.dataAndAttr('mp4-url', real.baseUri + '/uploadedfile/' + fileId + '/view');
            videoPlayer.dataAndAttr('poster-file-url', '');
            videoPlayer.dataAndAttr('background-url', '');
            videoPlayer.dataAndAttr('subtitle-lang', '');
            videoPlayer.dataAndAttr('subtitle-url', '');
            videoPlayer.dataAndAttr('download-file-url', '');
            videoPlayer.dataAndAttr('uploadedfile-id', fileId);
            videoPlayer.dataAndAttr('video-width', 0);
            videoPlayer.dataAndAttr('video-height', 0);
            videoPlayer.removeAttr('style');
        }

        // Remove loader and show attachment content
        attachment.find('.howspace-loader').remove();
        attachment.children().removeClass('d-none');

        howspace.components.init(attachment);
        attachment.find('input[name="attachments[]"]').val(fileId);
    }

    const getVideoDimensions = (url) => {
        return new Promise((resolve) => {
            const videoEle = document.createElement('video');
            videoEle.src = url;
            videoEle.addEventListener('loadedmetadata', () => {
                resolve({
                    width: videoEle.videoWidth,
                    height: videoEle.videoHeight
                });
            });
        });
    };

    const getAttachmentConfig = (widget, file, uploadedFileId) => {
        return {
            audio: {
                templateId: '#discussion-audio-attachment-template',
                prepareFileObject: (file) => ({
                    ...file,
                    audio_url: `${real.baseUri}/uploadedfile/${uploadedFileId}/view`,
                    audio_content_type: file.content_type,
                    audio_is_stored: true,
                }),
                postAppendAction: (_, widget) => howspace.components.audioPlayer.init(widget),
            },
            video: {
                templateId: '#discussion-video-attachment-template',
                prepareFileObject: async (file) => {
                    const url = `${real.baseUri}/uploadedfile/${uploadedFileId}/view`;
                    let { video_width: width, video_height: height } = file.metadata;

                    if (width === 0 && height === 0) {
                        ({ width, height } = await getVideoDimensions(url));
                    }

                    return {
                        ...file,
                        video_url: url,
                        is_stored: true,
                        video_width: width,
                        video_height: height,
                        poster_image_url: '',
                    };
                },
                postAppendAction: (_, widget) => howspace.components.videoPlayer.init(widget),
            },
            image: {
                templateId: '#discussion-image-attachment-template',
                prepareFileObject: (file) => ({
                    ...file,
                    src: `${real.baseUri}/uploadedfile/${uploadedFileId}/view`,
                }),
                postAppendAction: (file, _, attachments) => {
                    const picture = attachments.find(`.howspace-picture[data-uploadedfile-id="${uploadedFileId}"]`);
                    if (file.isAnnotation) {
                        picture.closest('.attachment').find('.rotate-attachment-btn').remove();
                    }
                    howspace.components.picture.replacePicture(
                        picture[0],
                        uploadedFileId,
                        `${real.baseUri}/uploadedfile/${uploadedFileId}/view`,
                        file.metadata
                    );
                },
            },
        }[file.file_type] || {
            templateId: '#discussion-file-attachment-template',
            prepareFileObject: (file) => {
                const icons = $(howspace.template.getElement(widget.find('template.file-icons-template')));
                let fileTypeLabel = howspace.translate('common_file_generic');
                if (file.icon != 'page') {
                    switch (file.icon) {
                        case 'file-pdf':
                            fileTypeLabel = howspace.translate('common_file_pdf');
                            break;
                        case 'file-excel':
                            fileTypeLabel = howspace.translate('common_file_excel');
                            break;
                        case 'file-word':
                            fileTypeLabel = howspace.translate('common_file_word');
                            break;
                        case 'file-zip':
                            fileTypeLabel = howspace.translate('common_file_zip');
                            break;
                        default:
                            fileTypeLabel = howspace.translate('common_file_generic');
                    }
                }

                return {
                    ...file,
                    icon: icons.find(`.icon.${file.icon}`)[0]?.outerHTML ?? '',
                    url: `${real.baseUri}/widget/discussion/${widget.data('widget-id')}/inline/${uploadedFileId}/download`,
                    file_type_label: fileTypeLabel
                };
            }
        };
    };

    const generateFileObject = async (config, file, uploadedFileId) => {
        if (typeof config.prepareFileObject === "function") {
            return await config.prepareFileObject(file, uploadedFileId);
        }
        return file;
    };

    const renderAttachment = (attachmentTemplate, fileObject, attachments) => {
        const html = howspace.template.getHtml(attachmentTemplate, fileObject);
        attachments.append(html);
        howspace.animate(attachments.find('.attachment:last'), 'slideDown', 350);
    };

    const addAttachment = async (widget, parentContainer, file, isAnnotation = false) => {
        const uploadedFileId = file.id;
        const attachments = parentContainer.find('.attachments');

        const config = getAttachmentConfig(widget, file, uploadedFileId);
        if (!config) {
            return;
        }

        if ($(config.templateId).length === 0) {
            return;
        }

        attachments.removeClass('d-none');

        const fileObject = await generateFileObject(config, file, uploadedFileId);
        fileObject.isAnnotation = isAnnotation;
        renderAttachment($(config.templateId), fileObject, attachments);

        if (typeof config.postAppendAction === "function") {
            config.postAppendAction(fileObject, widget, attachments);
        }
    };

    const handleFileUploadCompleted = (modal, modalOpener, uploadedFiles) => {
        const widget = $(modalOpener.closest('.widget'));
        if (widget.length === 0) {
            // No widget found from the DOM.
            return;
        }

        const parentContainer = getParent(modalOpener);

        uploadedFiles.forEach(file => {
            addAttachment(widget, parentContainer, file);
        });

        const sendBtn = parentContainer.find('.send-action-btn');
        sendBtn.prop('disabled', false);

        // Need to set focus after a short delay to ensure the button is focusable.
        setTimeout(() => {
            sendBtn.focus();
        }, 400);

        howspace.components.modal.close(modal);
    };

    let recordTimerInterval = null;
    /**
     * @param {*} widget
     */
    const countDownAndStartRecording = async (widget, type, opener) => {
        let recordingContainer;
        if ($(opener).closest('.comment-input').length > 0) {
            recordingContainer = $(opener).closest('.comment-input').find('.recording');
        } else if ($(opener).closest('.reply-input').length > 0) {
            recordingContainer = $(opener).closest('.reply-input').find('.recording');
        }
        recordingContainer.addClass(type);
        widget.dataAndAttr('recording-type', type);
        widget.data('opener', opener);
        const recordingButtonsMessage = recordingContainer.find('.recording-buttons-message');
        const recordingCountdown = recordingContainer.find('.recording-countdown');
        const recordingPreview = recordingContainer.find('.recording-preview');
        const recordTimer = recordingContainer.find('.record-timer');
        const recordingLoader = recordingContainer.find('.howspace-loader');

        const onMediaSuccess = (stream, type) => {
            recordingLoader.addClass('d-none');
            if (type === 'video') {
                recordingPreview.addClass('blur');
                recordingPreview.removeClass('d-none');
            }

            setTimeout(() => {
                const previewRect = recordingPreview[0].getBoundingClientRect();
                if (previewRect.top < $('#top').height() || previewRect.bottom > window.innerHeight) {
                    // Either the top or the bottom of the recording preview is not fully visible, scroll to it.
                    howspace.scroller.scrollToElement(recordingPreview);
                }
            }, 100);

            // Fade in the countdown and start the countdown animation
            howspace.animate(recordingCountdown, 'fadeIn', 350, () => {
                recordingCountdown.removeAttr('style').removeClass('d-none')
                recordingCountdown.prop('countdown', 4).animate(
                    { countdown: 0 },
                    {
                        duration: 4000,
                        easing: 'linear',
                        step: now => {
                            recordingCountdown.find('.count-down-text').html(Math.ceil(now));
                        },
                        complete: () => {
                            if (recordTimerInterval) {
                                clearInterval(recordTimerInterval);
                            }
                            if (type === 'video') {
                                recordingPreview.removeClass('blur');
                            }
                            recordTimer.html('00:00');
                            recordingCountdown.addClass('d-none');
                            recordingButtonsMessage.removeClass('d-none');

                            const updateInterval = 1000;
                            let startTime = 0;
                            recordTimerInterval = setInterval(() => {
                                startTime += updateInterval;
                                const { hours, minutes, seconds } = howspace.mediaRecorder.calculateTime(startTime);
                                const format = howspace.mediaRecorder.formatTime(hours, minutes, seconds);
                                recordTimer.html(format);
                            }, updateInterval);

                            howspace.mediaRecorder.start(stream, type);
                        }
                    }
                );
            });
        }

        const onMediaError = () => {
            recordingContainer.addClass('d-none');
            recordingCountdown.addClass('d-none');
            recordingLoader.addClass('d-none');

            if (type === 'video') {
                real.notification.show(howspace.translate('fileuploader_video_recording_error'), 'danger');
            } else if (type === 'audio') {
                real.notification.show(howspace.translate('fileuploader_audio_recording_error'), 'danger');
            }
        };

        if (type === 'video') {
            const permission = await howspace.mediaRecorder.checkAudio() && await howspace.mediaRecorder.checkVideo();
            if (!permission) {
                if (howspace.isMicrosoftTeamsSession()) {
                    real.notification.show(howspace.translate('fileuploader_video_recording_denied_teams'), 'danger');
                } else {
                    real.notification.show(howspace.translate('fileuploader_video_recording_denied'), 'danger');
                }
                return;
            }

            howspace.mediaRecorder.startVideo(recordingPreview[0], onMediaSuccess, onMediaError);
        } else if (type === 'audio') {
            const permission = await howspace.mediaRecorder.checkAudio();
            if (!permission) {
                if (howspace.isMicrosoftTeamsSession()) {
                    real.notification.show(howspace.translate('fileuploader_audio_recording_denied_teams'), 'danger');
                } else {
                    real.notification.show(howspace.translate('fileuploader_audio_recording_denied'), 'danger');
                }
                return;
            }

            howspace.mediaRecorder.startAudio(onMediaSuccess, onMediaError);
        }

        recordingContainer.removeClass('d-none');
        recordingLoader.removeClass('d-none');
        recordingPreview.addClass('d-none');
        recordingButtonsMessage.addClass('d-none');
        recordingCountdown.addClass('d-none');
    };

    /**
     * @param {*} widget
     */
    const cancelRecording = (widget) => {
        const recordingContainer = widget.find('.recording:visible');
        widget.removeDataAndAttr('recording-type');
        recordingContainer.removeClass('audio').removeClass('video').removeDataAndAttr('recording-type');
        howspace.animate(recordingContainer, 'slideUp', 350, () => {
            recordingContainer.removeAttr('style');
            recordingContainer.addClass('d-none');
            howspace.mediaRecorder.stop(() => {
                if (recordTimerInterval) {
                    clearInterval(recordTimerInterval);
                }
            });
        });
    };

    /**
     * @param {*} widget
     */
    const uploadRecording = (widget) => {
        const recordingContainer = widget.find('.recording');
        const type = widget.data('recording-type');
        let fileName = type + '-recording';

        recordingContainer.removeClass('audio').removeClass('video');
        recordingContainer.find('.howspace-loader').removeClass('d-none');
        recordingContainer.find('.recording-buttons-message').addClass('d-none');
        recordingContainer.find('.recording-countdown').addClass('d-none');
        recordingContainer.find('.recording-preview').addClass('d-none');

        howspace.mediaRecorder.stop(blob => {
            if (recordTimerInterval) {
                clearInterval(recordTimerInterval);
            }
            if (blob && blob.size > 0) {
                try {
                    const extension = howspace.mediaRecorder.getFileExtension(blob);

                    const formData = new FormData();
                    const token = real.uid();
                    formData.append('upload_process_metadata', JSON.stringify({
                        token: token
                    }));
                    formData.append('file', blob, fileName + extension);

                    real.ajax(real.baseUri + '/api/uploadedfiles', {
                        type: 'POST',
                        data: formData,
                        dataType: 'json',
                        contentType: false,
                        processData: false,
                        success: () => {
                            widget.dataAndAttr('attachment-upload-token', token);
                        }
                    });
                } catch (error) {
                    howspace.animate(recordingContainer, 'slideUp', 350, () => {
                        recordingContainer.removeAttr('style');
                        recordingContainer.addClass('d-none');
                    });
                    real.notification.show(
                        howspace.translate('fileuploader_recording_error'),
                        'danger'
                    );
                }
            }
        });
    };

    const rotateAttachment = (opener, attachment, angle) => {
        const attachmentId = attachment.find('input[name="attachments[]"').val();
        if (attachmentId.length === 0) {
            return;
        }

        const widget = $(opener).closest('.widget');
        const parentContainer = getParent(opener);
        parentContainer.find('.send-action-btn').prop('disabled', false);

        const token = real.uid();
        const dataPayload = {
            rotate: attachmentId,
            angle: angle,
            upload_process_metadata: {
                token: token
            }
        };

        real.ajax.json(real.baseUri + '/api/uploadedfiles', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: () => {
                attachment.addClass('rotating');
                attachment.dataAndAttr('attachment-rotating-token', token);
                widget.dataAndAttr('attachment-rotating-token', token);
                // Hide all visible children of the attachment while it's being rotated.
                attachment.children(':visible').addClass('d-none');
                const loader = `<div class="howspace-loader howspace-lister-loader medium"></div>`;
                attachment.append(loader);
            }
        });
    };

    return {
        addAttachment: addAttachment,
        handleFileUploadCompleted: handleFileUploadCompleted,
        countDownAndStartRecording: countDownAndStartRecording,
        cancelRecording: cancelRecording,
        uploadRecording: uploadRecording,
        rotateAttachment: rotateAttachment
    };
})();
